import React from 'react';

import MessagePropType from '../definitions/MessagePropType';
import { MessageBannerVariants } from '../definitions/MessageBannerDefinitions';
import MessageBanner from './MessageBanner';


function MessageBannerError({ message, ...otherProps }) {
    return (
        <MessageBanner
            iconKey="exclamation-mark"
            variant={MessageBannerVariants.ERROR}
            message={message}
            {...otherProps}
        />
    );
}

MessageBannerError.propTypes = {
    message: MessagePropType.isRequired,
};

export default MessageBannerError;
